import React from "react";
import { motion } from "framer-motion";
import Link from "next/link";

const Finance = () => {
  return (
    <section className="py-16 px-6 sm:px-12 lg:px-24 bg-pri text-white">
      <div className="max-w-6xl mx-auto text-center">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h3 className="text-lg md:text-2xl font-bold mb-4">
          Power Your Future with Affordable Solar Financing
          </h3>
          <p className="text-lg mb-8 max-w-3xl mx-auto">
            At Satyanam Solar, we&apos;re revolutionizing solar accessibility with comprehensive financial solutions tailored for Indian homes and businesses.          
          </p>
          <Link href="/finance" className="border border-white text-white hover:border-gray-400 font-semibold py-3 px-8 rounded-lg transition duration-300">
            Check out our Finance Plans
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default Finance;
